import type { AIModelChoices } from 'api';

import { isLooseAiModel } from '../../../evidence';
import { ASPECT_RATIO, type AspectRatioType } from '../../config';

export const getAspectRatio = ({
  aiModel,
  isPortrait,
}: {
  aiModel: AIModelChoices;
  isPortrait: boolean;
}): AspectRatioType => {
  if (isLooseAiModel(aiModel)) {
    return ASPECT_RATIO.SQUARE;
  }
  return isPortrait ? ASPECT_RATIO.PORTRAIT : ASPECT_RATIO.LANDSCAPE;
};

export const captureImage = ({ video }: { video: HTMLVideoElement }): Promise<File | null> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas?.toBlob((blob) => {
        if (blob) {
          resolve(new File([blob], 'photo.jpg', { type: 'image/jpeg' }));
        } else {
          resolve(null);
        }
      }, 'image/jpeg');
    } else {
      resolve(null);
    }
  });
};
